<template>
  <div class="main-container">
    <div class="left">
      <div class="left-title">System name</div>
      <el-input v-model="keyword" @input="filterVendor" maxlength="128" size="medium" placeholder="System"></el-input>
      <div class="vender-list" ref="venderList">
        <div class="vendor-item" v-for="(item, index) in vendorList" @click="clickVendor(item, index)" :class="{active: vendorSystemId == item.vendorSystemId}" :key="item.vendorSystemId">{{ item.systemName }}</div>
      </div>
    </div>
    <div class="vendor">当前：{{ vendorSystemName }}</div>
    <el-tabs v-model="mainTab" type="card">
      <el-tab-pane label="Category" name="category">
        <category v-if="vendorSystemId" ref="category" :vendorSystemId="vendorSystemId"></category>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as _ from "lodash";
import {
  getSystemList,
} from '../../../api/mapping_cn';
import Category from './category';

export default {
  components: {
    Category,
  },
  data() {
    return {
      mainTab: 'category',
      keyword: '',
      vendorList: [],
      vendorSystemId: null,
      vendorSystemName: '',
    };
  },
  mounted() {
    getSystemList().then(res => {
      if (res.data && res.data.data) {
        this.vendorData = JSON.parse(JSON.stringify(res.data.data));
        this.vendorList = res.data.data;
      }
    });
  },
  methods: {
    filterVendor(query) {
      if (query) {
        const temp = [];
        for (let i = 0; i < this.vendorData.length; i++) {
          if (!this.vendorData[i].systemName) {
            continue;
          }
          const name = this.vendorData[i].systemName.toUpperCase();
          const str = query.toUpperCase();
          if (name.startsWith(str)) {
          // if (name.indexOf(str) >= 0) {
            temp.push(this.vendorData[i]);
          }
        }
        this.vendorList = temp;
        this.$nextTick(() => {
          this.$refs.venderList.scrollTop = 0;
        })
      } else {
        this.vendorList = this.vendorData;
        setTimeout(() => {
          this.$refs.venderList.scrollTop = document.querySelector('.vendor-item.active').offsetTop;
        },10)
      }
    },
    clickVendor(item, index) {
      this.vendorSystemId = item.vendorSystemId;
      this.vendorSystemName = item.systemName;
      this.$nextTick(() => {
        this.$refs.category.trigger();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mb10 {
  margin-bottom: 10px;
}
.main-container {
  position: relative;
  min-height: 100%;
  padding: 10px 10px 10px 190px;

  .left {
    position: absolute;
    top: 0;
    left: 10px;
    bottom: 0;
    width: 170px;
    padding-right: 10px;
    border-right: 1px solid #E4E7ED;
  }
  .left-title {
    font-size: 14px;
    line-height: 40px;
  }
  .vender-list {
    position: absolute;
    top: 85px;
    left: 0;
    bottom: 0;
    right: 4px;
    overflow: auto;
  }
  .vendor-item {
    padding: 7px 10px;
    font-size: 14px;
    text-align: right;
    word-break: break-all;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
      background-color: #f5f7fa;
    }
    &.active {
      color: #fff;
      background-color: #409EFF;
    }
  }
}
.vendor {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}
.search {
  display: block;
  width: 310px;
  margin-bottom: 10px;
}
.table {
  width: 100%;
  margin-bottom: 10px;
  border-spacing: 0;
  border-collapse: collapse;

  tr{
    border-bottom: 1px solid #ebeef5;
    
    &:hover {
      background-color: #f5f7fa;
    }
  }
  td {
    padding: 10px;
  }
}
.brand-name {
  margin-top: 8px;
  font-size: 16px;
}
.tag-group {
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.tag {
  position: relative;
  margin: 10px 10px 0 0;
  padding: 5px 26px 5px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  i {
    position: absolute;
    top: 50%;
    right: 0;
    padding: 8px 5px;
    margin-top: -16px;
    line-height: 100%;
    cursor: pointer;

    &:hover {
      color: #000;
      font-weight: bold;
    }
  }

  &:hover{
    border-color: #C0C4CC;
  }
}
</style>
